<template>
	<div :class="['profile-ud-item sip-kv-item', colSpanClass]">
		<div class="profile-ud">
			<span class="profile-ud-label sip-kv-label">{{label}}</span>
			<span class="profile-ud-value sip-kv-value">
				<template v-if="isEmptyValue">
					<span class="profile-ud-empty sip-kv-empty">—</span>
				</template>
				<template v-else>
					<template v-if="type === 'date'">
						<span>{{value | moment}}</span>
					</template>
					<template v-else-if="type === 'datetime'">
						<span>{{value | momentDateTime}}</span>
					</template>
					<template v-else>
						<span v-if="toUppercaseWord">{{ucword(value)}}</span>
						<span v-else>{{value}}</span>
					</template>
				</template>
			</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ViewLabel',
		props: {
			label: {
				type: String,
				default: 'Label'
			},
			type: {
				type: String,
				default: 'string'
			},
			value: {
				default: ''
			},
			toUppercaseWord: {
				type: Boolean,
				default: false
			},
			colSpan: {
				type: [Number, String],
				default: 1
			}
		},
		computed: {
			isEmptyValue() {
				return this.value === null || 
					   this.value === undefined || 
					   this.value === '' || 
					   this.value === '-' || 
					   this.value === 'null' || 
					   this.value === 'undefined';
			},
			colSpanClass() {
				const span = parseInt(this.colSpan, 10);
				if (span === 2) return 'sip-col-span-2';
				if (span === 3) return 'sip-col-span-3';
				if (span >= 4) return 'sip-col-span-full';
				return '';
			}
		},
		methods: {
			ucword(word) {
				return helper.ucword(word);
			}
		}, 
        filters: {
          moment(date) {
            return helper.formatDate(date);
          },
          momentDateTime(date) {
            return helper.formatDateTime(date);
          }
        }
	}
</script>
